// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"_2t7nm","BackImage":"_398zZ","Heading":"v6BjM"};


//////////////////
// WEBPACK FOOTER
// ./src/components/BackToAdminCentre/BackToAdminCentre.scss
// module id = 1941
// module chunks = 0